import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const AccordionItem = ({ title, content, open, html }) => {
  const [isOpen, setIsOpen] = useState(open || false);

  return (
    <div className="border rounded-lg overflow-hidden">
      <button
        className="w-full text-left p-4 hover:bg-gray-100 duration-300 flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        {html ? (
          <span
            dangerouslySetInnerHTML={{ __html: title }}
            className="font-medium"
          />
        ) : (
          <span className="font-medium">{title}</span>
        )}

        <span>{isOpen ? "▲" : "▼"}</span>
      </button>
      {isOpen && (
        <>
          {html ? (
            <div
              className="text-md !p-4 border-t bg-white text-gray-700 [&_ol]:pl-4 [&_ul]:pl-4 [&_menu]:pl-4"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          ) : (
            <div className="text-md !p-4 border-t bg-white text-gray-700 [&_ol]:pl-4 [&_ul]:pl-4 [&_menu]:pl-4">
              {content}
            </div>
          )}
        </>
      )}
    </div>
  );
};

const Accordion = ({ accordionData, fullWidth, openFirst, html }) => {
  const location = useLocation();

  return (
    <div className={location.pathname === "/" ? "sm:mt-24 mt-12" : ""}>
      <div
        className={
          fullWidth
            ? "grid grid-cols-1 gap-6"
            : "container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6"
        }
      >
        {accordionData.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.title}
            content={item.content}
            open={openFirst && index === 0}
            html={html}
          />
        ))}
      </div>
    </div>
  );
};

export default Accordion;
